export default {
  author: {},
};
